{
  "iframeWaitingMessage": "Grazie per l’attesa. Ancora qualche istante...",
  "solutionIframe": "Contenuto principale"
}
